(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var selector = [
    '.shopify-section .grid__item',
    '.shopify-section .multicolumn-card',
    '.shopify-section .collection-list__item',
    '.shopify-section .banner__content',
    '.shopify-section .title-wrapper-with-link',
    '.shopify-section .newsletter-form',
    '.shopify-section .image-with-text__content',
    '.shopify-section .image-with-text__media-item'
  ].join(',');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;

    if (reduceMotion) {
      els.forEach(function (el) {
        el.classList.add('reveal-init', 'is-revealed');
      });
      return;
    }

    var counters = new WeakMap();
    els.forEach(function (el) {
      var parent = el.parentElement;
      var n = counters.get(parent) || 0;
      var delay = Math.min(n, 6) * 60;
      el.style.setProperty('--reveal-delay', delay + 'ms');
      counters.set(parent, n + 1);
      el.classList.add('reveal-init');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) { io.observe(el); });
  });
})();
